import angular from 'angular';

angular.module("merchant.application.main").factory("merchant.application.main.factory.instore",
    function() {

        var expose = {};

        expose.header = function() {
            return [
                {
                    text: "In-store (Barcode)",
                    link: "in-store/barcode",
                    name: ["in-store-barcode"],
                    permissions: "ACTIVATE_DEVICE, CREATE_ORDER",
                    channels: "IN_STORE"
                },
                {
                    text: "Afterpay Card",
                    link: "in-store/card/acquirer-details",
                    name: ["in-store-card-acquirer-details"],
                    permissions: "VIEW_POS_CARD, EDIT_POS_CARD",
                    channels: "IN_STORE_CARD IN_STORE_CARD_ONLINE"
                }
            ];
        };

        expose.featureDisabledHeader = function() {
            return [
                {
                    text: "In-store (Barcode)",
                    link: "in-store/barcode",
                    name: ["in-store-barcode"],
                    permissions: "ACTIVATE_DEVICE, CREATE_ORDER",
                    channels: "IN_STORE"
                }
            ];
        };

        return expose;
    }
);
